<div class="upload-logo" (click)="imageInput.click()" [ngClass]="{small: isSmall}">
  <ng-container *ngIf="!isLoading; else smallSpinner">
    <div
      *ngIf="srcLogo; else placeholder"
      class="logo-image"
      [style.background-image]='"url(\"" + srcLogo + "\")"'>
    </div>
    
    
    <ng-template #placeholder>
      <div class="upload-logo-placeholder">
        <img class="upload-logo-placeholder_img" src="./assets/images/photo.svg" alt="">
        <p class="upload-logo-placeholder_text" *ngIf="shouldShowPlaceholderText">Upload Logo</p>
      </div>
    </ng-template>
  </ng-container>

  <input
    #imageInput
    type="file"
    [accept]="photoAllowedExt"
    [size]="fileSize"
    (change)="uploadImage($event)"
    [hidden]="true"
    name="budgetLogo">
</div>


<ng-template #smallSpinner>
  <i class="fa-spin fas fa-spinner"></i>
</ng-template>
